<template>
  <AuthForm
    v-model="formData"
    title="Sign up"
    description="Create your account to get started"
    :rules="rules"
    @submit="handleSubmit"
  >
    <div class="form-row mb-20px">
      <ElFormItem prop="email" class="full-width">
        <AppInput
          v-model="formData.email"
          label="Email"
          placeholder="Enter email address"
          validate-event
          type="email"
          :required="true"
        />
      </ElFormItem>
    </div>

    <div class="form-row mb-20px">
      <ElFormItem prop="password" class="full-width">
        <AppInput
          v-model="formData.password"
          label="Password"
          placeholder="Enter password"
          type="password"
          :required="true"
        />
      </ElFormItem>
    </div>

    <div class="form-row mb-20px">
      <ElFormItem prop="passwordConfirmation" class="full-width">
        <AppInput
          v-model="formData.passwordConfirmation"
          label="Confirm password"
          placeholder="Confirm password"
          type="password"
          :required="true"
        />
      </ElFormItem>
    </div>

    <template #footer>
      <div class="d--f jc--c full-width mt-20px">
        <div>
          Already have an account? <router-link :to="{ name: 'login' }" class="router-link-plain">Sign in</router-link>
        </div>
      </div>
    </template>
  </AuthForm>
</template>

<script setup>
import { reactive } from "vue";
import { useRouter } from "vue-router";
import { ElFormItem } from "element-plus";
import { AppInput } from "@/components/ui";

import AuthApi from "@/api/auth";
import AuthForm from "@/views/Auth/components/AuthForm.vue";
import { showToast } from "@/utilities/toast";
import { formatErrorMessages } from "@/utilities/errors";

const router = useRouter();

const formData = reactive({
  email: "",
  password: "",
  passwordConfirmation: "",
});

const rules = {
  email: [
    { required: true, message: "Please enter an email address", trigger: "blur" },
    { type: "email", message: "Please enter a valid email address", trigger: "blur" },
  ],
  password: [
    { required: true, message: "Please enter a password", trigger: "blur" },
    { min: 8, message: "Password must be at least 8 characters long", trigger: "blur" },
  ],
  passwordConfirmation: [
    { required: true, message: "Please confirm password", trigger: "blur" },
    {
      validator: (_, value, callback) => {
        value !== formData.password ? callback(new Error("Passwords don't match")) : callback();
      },
      trigger: "blur",
    },
  ],
};

const handleSubmit = async () => {
  const response = await AuthApi.register(formData.email, formData.password, formData.passwordConfirmation);

  if (response.errors) {
    showToast(formatErrorMessages(response.errors), { type: "error" });
  } else {
    showToast("Registration successful! Please check your email to confirm your account.", {
      type: "success",
    });
    router.push({ name: "login" });
  }
};
</script>
